import i18n from 'i18next';
import backend from 'i18next-http-backend';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
export const availableLanguages = ['en', 'id', 'vi', 'ms'];

i18n
  .use(backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      //   translation file path
      loadPath: '/assets/i18n/{{lng}}.json',
    },
    supportedLngs: availableLanguages,
    fallbackLng: 'en',
    // disabled in prod
    debug: false,
    // can have multiple namespaces, in case we have huge translation files
    nsSeparator: '',
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
    react: {
      useSuspense: true,
    },
  });
export default i18n;
